import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { DeleteMembershipPlanModel } from "../../models/business/delete-membership-plan.model";
import { MembershipPlanModel } from "../../models/business/membership-plan.model";
import { SearchMembershipPlanModel } from "../../models/business/search-membership-plan.model";
import { HttpService } from "../common/http-service";

const PRODUCT_API = environment.apiURL + '/api/adm/Product/';
@Injectable({
    providedIn: 'root'
})
export class MembershipPlanService {

    //#region Fields

    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods
    getproducts(model: SearchMembershipPlanModel) {
        var url = PRODUCT_API + "getproducts";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getproductbyid(id: string) {
        var url = PRODUCT_API + 'getproduct?productId=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getallcountrynames() {
        var url = PRODUCT_API + 'getallcountrynames';
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    addproduct(model: MembershipPlanModel) {
        var url = PRODUCT_API + "addproduct";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updateproduct(model: MembershipPlanModel) {
        var url = PRODUCT_API + "updateproduct";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    deleteproduct(model: DeleteMembershipPlanModel) {
        var url = PRODUCT_API + "deleteproduct";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllProjects() {
      var url = PRODUCT_API + "getallprojectnames";
      return this._httpService.httpGet(url)
        .pipe(map(resposne => {
          return resposne;
        }));
    }
    //#endregion
}
